<template>
  <div>
  <b-card>
    <b-row class="temp_mapping">
      <b-col cols="8" class="text-left">
        <h4>{{ $t('Validations') }}</h4>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-button type="submit" size="sm" variant="secondary" class="mt-0" v-b-modal.externalServiceValidation >
          <i class="fa fa-plus"> </i> <span> {{ $t('Add new validation') }} </span>
        </b-button>
        <b-button type="submit" size="sm" variant="secondary" class="mt-0" v-b-modal.importValidations >
          <i class="fa fa-upload"> </i> <span> {{ $t('Import validations') }} </span>
        </b-button>
      </b-col>
    </b-row>
  </b-card>
  <b-row>
    <b-col cols="6" v-for="validation in externalServiceValidations" :key="validation.id">
      <b-card>
        <b-card border-variant="info" align="left">
          <div slot="header">
              <b-row>
                <b-col md="8">
                  <h5>Validation</h5>
                </b-col>
                <b-col md="4">
                  <div class="float-right add-field-btn">
                    <b-button type="submit" size="sm" variant="primary" class="mt-0" @click="editExternalServiceValidation(validation.template_doc_id)"><i class="fa fa-edit"></i></b-button>
                    <b-button type="submit" size="sm" variant="danger" class="mt-0" @click="showDeleteModal(validation.template_doc_id)"><i class="fa fa-trash"></i></b-button>
                  </div>
                </b-col>
              </b-row>
            </div>
          <p class="card-text">
            <b-row >
              <b-col cols="4">Template:</b-col>
              <b-col cols="8 text-left">{{validation.template}}</b-col>
            </b-row>
          </p>
        </b-card>
      </b-card>
    </b-col>
  </b-row>
    <!-- External Service Modal -->
    <b-modal id="externalServiceValidation" size="lg" class="external-service-validation-modal" :title="extServiceValidation.created ? 'New Validation' : 'Edit Validation'" hide-footer header-bg-variant="light" ref="externalServiceValidationModal" @hidden="onHidingExtSerValModal">
      <b-row>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Template:</b-col>
              <b-col cols="7 text-left">
                <model-select class="modelSelect" :plain="true" v-model="templateDoc.selectedTemplateDocId" :options="availableTemplateDocs" placeholder="Select Template"></model-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showVersionsRow">
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Page:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplate" :options="availableTemplates" @change="fetchTemplateVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Version:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplateVersion" :options="availableTemplateVersions" @change="handleSelectedVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showFetchButton">
        <b-col cols="8 text-left">
          <b-btn size="sm" class="float-right" @click="fetchValidations" variant="secondary mr-1"  :disabled="!(templateDoc.selectedTemplateDocId && selectedTemplate && selectedTemplateVersion)" >Fetch</b-btn>
        </b-col>
      </b-row>
      <b-row v-if="showESV">
        <b-col cols="4">
          <b-card border-variant="info"
                header="Map Fields"
                align="center" >
            <p class="card-text">
              <b-row>
                <b-col cols="11 text-left">
                  <label>Template Fields</label>
                  <model-select class="modelSelect" :plain="true" :options="templateDoc.tmpFields" v-model="externalServiceValidation.selectedTmpField" placeholder="Select Template Field"></model-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="11 text-left">
                  <label>Condition</label>
                  <b-form-select :plain="true" :options="conditions" v-model="externalServiceValidation.selectedCondition"></b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="11 text-left">
                  <label>Value</label>
                  <b-form-input :plain="true" v-model="externalServiceValidation.conditionValue"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="11 text-left">
                  <label>Error Message</label>
                  <b-form-input :plain="true" v-model="externalServiceValidation.errorMessage"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="2 text-left">
                  <label>Action</label>
                  <b-btn size="sm" style="padding: 1px 10px; border-radius: 10px" @click="addFieldValidation" variant="secondary" ><span v-if="this.editValidationId !== null">Update</span><span v-else>Add</span></b-btn>
                </b-col>
              </b-row>
            </p>
          </b-card>
        </b-col>
        <b-col cols="8">
          <b-card border-variant="info"
                          align="left" >
                      <div slot="header">
                        <b-row style="margin: 0px">
                          <b-col md="10">
                            <h6 style="margin: 1px 0px 0px 0px">Validation Fields</h6>
                          </b-col>
                          <b-col md="2">
                            <i class="fa fa-download download-efm fa-lg" @click="downloadEsvalidations" v-b-tooltip.hover title='Download ExternalValidations'></i>
                          </b-col>
                        </b-row>
                      </div>
            </b-card>
          <b-card border-variant="info"
                align="left" >
            <p class="card-text">
              <b-table hover :fields="fields" :items="this.externalServiceValidation.externalServiceValidations">
                <template slot="tmp_key" slot-scope="data">{{data.item.tmp_key}} ({{data.item.condition}})</template>
                <template slot="actions" slot-scope="data"> 
                  <i class="fa fa-trash" style="color: red; cursor: pointer;" @click="deleteExternalFieldMap(data.item.id)" />
                  <i class="fa fa-edit" style="cursor: pointer;" @click="editExternalFieldMap(data.item)" />
                </template>
              </b-table>
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="importValidations" size="lg" class="external-service-validation-modal" title="Import Validations" hide-footer header-bg-variant="light" ref="externalServiceImportValidationModal" @hidden="onHidingExtSerValModal">
      <b-row>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Template:</b-col>
              <b-col cols="7 text-left">
                <b-form-select class="modelSelect" :plain="true" v-model="templateDoc.selectedTemplateDocId" :options="availableTemplateDocs" placeholder="Select Template"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showVersionsRow">
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Page:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplate" :options="availableTemplates" @change="fetchTemplateVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Version:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplateVersion" :options="availableTemplateVersions" @change="handleSelectedVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
            <b-row>
              <b-col cols="4">Select File:</b-col>
              <b-col cols="8 text-left">
                <input id="fileUpload" type="file" ref="file" v-on:change="handleFileUpload()">
              </b-col>
            </b-row>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col cols="4"/>
          <div>
            <b-btn size="sm" variant="secondary" @click="saveImportValidations" :disabled="!isFileSelected"> {{ $t('CONFIGURED.CREATE') }} </b-btn>
            <b-btn size="sm" variant="light" @click="hideImportValidations"> {{ $t('COMMON.CLOSE') }} </b-btn>
          </div>
        </b-row>
    </b-modal>
  </b-card>
  <b-modal centered
  id="deleteModal"
  ref="deleteModal"
  :title="$t('COMMON.DELETE_CONFIRM')"
  no-close-on-esc
  no-close-on-backdrop
  hide-header-close
  :ok-title="$t('COMMON.DELETE')"
  :cancel-title="$t('COMMON.CANCEL')"
  ok-variant="secondary"
  cancel-variant="light"
  @cancel="cancel"
  @keydown.native.enter="deleteExternalServiceValidation"
  @ok="deleteExternalServiceValidation" >
  <div class="delete-warning">
    <p>{{$t('COMMON.DEL_SERVICEVALIDATION')}}</p>
  </div>
  </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import { ModelSelect } from 'vue-search-select'

export default {
  data () {
    return {
      conditions: [
        { text: 'Alphabatic', value: 'alphabatic' },
        { text: 'Numeric', value: 'numeric' },
        { text: 'Email', value: 'email' },
        { text: 'Length', value: 'lengthmeasurement' },
        { text: 'Phone Number', value: 'phonenumber' },
        { text: 'Date', value: 'date' },
        { text: 'Date with future', value: 'date_future' },
        { text: 'Reg Ex', value: 'regex' },
        { text: 'State', value: 'state' }
      ],
      fields: [
        { key: 'tmp_key', label: 'Template Field', tdClass: 'text-left', thClass: 'text-left' },
        { key: 'value', label: 'Value', tdClass: 'text-left', thClass: 'text-left' },
        { key: 'error_message', label: 'Error Msg', tdClass: 'text-left', thClass: 'text-left' },
        { key: 'actions', label: 'Actions' }
      ],
      externalServiceValidations: [],
      isFileSelected: false,
      availableTemplateDocs: [],
      availableTemplates: [],
      availableTemplateVersions: [],
      selectedTemplate: null,
      selectedTemplateVersion: null,
      showVersionsRow: false,
      showFetchButton: false,
      showESV: false,
      template_doc_id: null,
      extServiceValidation: {
        created: true
      },
      templateDoc: {
        selectedTemplateDocId: null,
        tmpFields: []
      },
      externalServiceValidation: {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: [],
        editValidationId: null
      }
    }
  },
  components: {
    ModelSelect
  },
  computed: {
    ...mapGetters(['idToken', 'selectedRolesData', 'isAdminRole', 'accountId'])
  },
  watch: {
    'templateDoc.selectedTemplateDocId': function () {
      this.resetData(true)
      this.fetchData(this.templateDoc.selectedTemplateDocId)
    }
  },
  created () {
    let vm = this
    Vue.axios.get('/settings/external_service_validations', { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        vm.externalServiceValidations = res.data.external_service_validations
        vm.availableTemplateDocs = [].concat(res.data.available_templates)
      })
      .catch(error => {
        if (error.status === 401) {
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  methods: {
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      this.isFileSelected = true
      const reader = new window.FileReader()
      reader.onload = evt => {
        try {
          this.text = JSON.parse(evt.target.result)
        } catch (error) {
          this.isFileSelected = false
          Vue.toasted.show(this.$t('COMMON.FILE_ERROR'), { icon: 'chain-broken', type: 'error' })
          return
        }
        let payload = {
          template_doc_id: this.templateDoc.selectedTemplateDocId,
          template_id: this.selectedTemplate,
          revision_id: this.selectedTemplateVersion,
          validation_data: this.text
        }
        this.validationPayload = payload
      }
      reader.readAsText(this.file)
    },
    showDeleteModal (templateDocId) {
      this.template_doc_id = templateDocId
      this.$refs['deleteModal'].show()
    },
    cancel () {
      this.$refs['deleteModal'].hide()
    },
    onHidingExtSerValModal () {
      this.templateDoc.selectedTemplateDocId = null
      this.resetData()
    },
    hideImportValidations () {
      this.$refs.externalServiceImportValidationModal.hide()
    },
    resetData () {
      this.availableTemplates = []
      this.availableTemplateVersions = []
      this.selectedTemplate = null
      this.selectedTemplateVersion = null
      this.showVersionsRow = false
      this.showESV = false
      this.showFetchButton = false
      this.extServiceValidation = {
        created: true
      }
      this.templateDoc.tmpFields = []
      this.externalServiceValidation = {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: []
      }
      this.editValidationId = null
    },
    handleSelectedVersion () {
      this.showESV = false
      this.showFetchButton = true
    },
    fetchData (newValue) {
      this.showVersionsRow = false
      Vue.axios.get('/settings/external_service_validations/fetch_templates?template_doc_id=' + newValue, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let result = res.data
          this.showVersionsRow = true
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplateVersion (newValue) {
      this.showESV = false
      this.selectedTemplateVersion = null
      if (newValue) {
        Vue.axios.get('/settings/external_service_validations/fetch_versions?template_id=' + newValue, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            let result = res.data
            this.availableTemplateVersions = [{text: 'Select version', value: null, disabled: true}].concat(result.versions)
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    fetchValidations () {
      let validationData = new window.FormData()
      validationData.append('template_doc_id', this.templateDoc.selectedTemplateDocId)
      validationData.append('template_id', this.selectedTemplate)
      validationData.append('revision_id', this.selectedTemplateVersion)
      Vue.axios.post('/settings/external_service_validations/fetch_validations', validationData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.status === 'SUCCESS') {
            this.showFetchButton = false
            let result = response.data
            this.showESV = true
            this.externalServiceValidation.externalServiceValidations = result.external_field_validations
            this.templateDoc.tmpFields = result.template_fields
            this.templateDoc.tmpFields.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0))
            Vue.toasted.show(response.data.message)
          } else {
            Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    addFieldValidation () {
      if (this.externalServiceValidation.selectedTmpField === '' || this.externalServiceValidation.selectedCondition === '' || this.externalServiceValidation.selectedTmpField === undefined) {
        Vue.toasted.show('Template and Condition fields are required.', { icon: 'chain-broken', type: 'error' })
        return
      } else if (['lengthmeasurement', 'regex', 'date', 'date_future'].includes(this.externalServiceValidation.selectedCondition) && this.externalServiceValidation.conditionValue === '') {
        Vue.toasted.show('Value field is required.', { icon: 'chain-broken', type: 'error' })
        return
      } else if (!(['lengthmeasurement', 'regex', 'date', 'date_future'].includes(this.externalServiceValidation.selectedCondition)) && this.externalServiceValidation.conditionValue !== '') {
        Vue.toasted.show('Value field must be empty.', { icon: 'chain-broken', type: 'error' })
        return
      }
      let validationData = new window.FormData()
      let mappingElement = this.templateDoc.tmpFields.filter((element) => element.value === this.externalServiceValidation.selectedTmpField)
      validationData.append('template_doc_id', this.templateDoc.selectedTemplateDocId)
      validationData.append('template_id', this.selectedTemplate)
      validationData.append('revision_id', this.selectedTemplateVersion)
      validationData.append('template_mapping_id', this.externalServiceValidation.selectedTmpField)
      validationData.append('template_mapping_key', mappingElement[0].text)
      validationData.append('condition', this.externalServiceValidation.selectedCondition)
      validationData.append('value', this.externalServiceValidation.conditionValue.trim())
      validationData.append('error_message', this.externalServiceValidation.errorMessage.trim())
      if (this.editValidationId === null) {
        Vue.axios.post('/settings/external_service_validations', validationData, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            if (response.data.status === 'SUCCESS') {
              let result = response.data
              this.externalServiceValidation.externalServiceValidations.push({'id': result.id, 'tmp_id': result.tmp_id, 'tmp_key': result.tmp_key, 'condition': result.condition, 'value': result.value, 'error_message': result.error_message})
              this.externalServiceValidations = this.externalServiceValidations.filter((key, index) => { return key.template_doc_id !== result.external_service_validation.template_doc_id }).concat(result.external_service_validation)
              this.externalServiceValidation.errorMessage = ''
              this.externalServiceValidation.conditionValue = ''
              this.externalServiceValidation.selectedTmpField = ''
              this.externalServiceValidation.selectedCondition = ''
              Vue.toasted.show(response.data.message)
            } else {
              Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        Vue.axios.patch('/settings/external_service_validations/' + this.editValidationId, validationData, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            if (response.data.status === true) {
              let result = response.data
              this.externalServiceValidation.externalServiceValidations = this.externalServiceValidation.externalServiceValidations.filter((esv, index) => { return esv.id !== this.editValidationId })
              this.externalServiceValidation.externalServiceValidations.push({'id': this.editValidationId, 'tmp_id': this.externalServiceValidation.selectedTmpField, 'tmp_key': result.tmp_key, 'condition': result.condition, 'value': this.externalServiceValidation.conditionValue, 'error_message': this.externalServiceValidation.errorMessage})
              this.externalServiceValidation.errorMessage = ''
              this.externalServiceValidation.conditionValue = ''
              this.externalServiceValidation.selectedTmpField = ''
              this.externalServiceValidation.selectedCondition = ''
              this.editValidationId = null
              Vue.toasted.show(response.data.message)
            } else {
              Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    editExternalFieldMap (validationData) {
      let field = this.templateDoc.tmpFields.filter(obj => {
        return obj.text === validationData.tmp_key
      })
      this.externalServiceValidation.selectedTmpField = field[0].value
      let condition
      if (validationData.condition === 'lengthmeasurement') {
        condition = 'lengthmeasurement'
      } else {
        condition = validationData.condition
      }
      this.externalServiceValidation.selectedCondition = condition
      this.externalServiceValidation.conditionValue = validationData.value.trim()
      this.externalServiceValidation.errorMessage = validationData.error_message.trim()
      this.editValidationId = validationData.id
    },
    editExternalServiceValidation (templateDocId) {
      Vue.axios.get('/settings/external_service_validations/' + templateDocId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          let result = response.data
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
          this.availableTemplateVersions = [{text: 'Select Versions', value: null, disabled: true}].concat(result.versions)
          this.selectedTemplate = result.templates[0]['value']
          this.selectedTemplateVersion = result.versions[0]['value']
          this.showVersionsRow = true
          this.externalServiceValidation.externalServiceValidations = result.external_field_validations
          this.templateDoc.selectedTemplateDocId = result.template_doc_id
          this.templateDoc.tmpFields = result.template_fields
          this.templateDoc.tmpFields.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0))
          this.showESV = true
          this.$refs.externalServiceValidationModal.show()
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            console.log(error)
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteExternalServiceValidation () {
      let validationData = new window.FormData()
      validationData.append('template_doc_id', this.template_doc_id)
      Vue.axios.post('/settings/external_service_validations/delete_template_validations', validationData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.deleted) {
            this.externalServiceValidations = this.externalServiceValidations.filter((key, index) => { return key.template_doc_id !== this.template_doc_id })
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteExternalFieldMap (validationId) {
      Vue.axios.delete('/settings/external_service_validations/' + validationId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.externalServiceValidation.externalServiceValidations = this.externalServiceValidation.externalServiceValidations.filter((esv, index) => { return esv.id !== validationId })
          Vue.toasted.show(this.$t('COMMON.MSG_FIELD_DEL'))
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    saveImportValidations () {
      Vue.axios.post('/settings/external_service_validations/save_import_validations', this.validationPayload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
            this.$refs.externalServiceImportValidationModal.hide()
            if (!res.data.error) {
              router.go()
            }
          } else {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadEsvalidations () {
      let parameters = {
        template_doc_id: this.templateDoc.selectedTemplateDocId,
        template_id: this.selectedTemplate,
        revision_id: this.selectedTemplateVersion
      }
      Vue.axios.get('/settings/external_service_validations/download_esvalidations', { headers: { Authorization: `Bearer ${this.idToken}` }, params: parameters })
        .then(res => {
          this.validationData = res
          const data = JSON.stringify(this.validationData.data.validations)
          const templateName = JSON.stringify(this.validationData.data.template_name).replace(/\s+/g, '_')
          const filename = templateName + '_external_service_validations' + '_version' + this.selectedTemplateVersion + '.txt'
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data))
          element.setAttribute('Download', filename)
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(error)
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.modelSelect /deep/ div.text{
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.delete-warning {
  font-size : 1rem;
  color: red;
}
.card {
  background: #ebeff3;
  border-radius: 10px;
}
.card-header {
  background: #f7f7f7;
}
.temp_mapping {
  background: #f8f9fa;
  padding: 0.5rem;
  margin: 0;
}
.external-service-modal {
  .row {
    margin-bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/externalServiceValidations.vue